export enum ReconfigureAgentPanelEvents {
  OnPanelClose = 'reconfigurePanelEventClose',
  OnViewInit = 'reconfigureAgentOnViewInit',
}

export class OnReconfigurePanelClose extends CustomEvent<{}> {
  constructor() {
    super(ReconfigureAgentPanelEvents.OnPanelClose, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}
